// extracted by mini-css-extract-plugin
module.exports = {"lds-dual-ring":"loader_lds-dual-ring__L2xLp","ldsDualRing":"loader_lds-dual-ring__L2xLp"};